import { Divider, Empty, Typography } from 'antd'
import React from 'react'

const WashReportPage = () => {
  return (
    <>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Typography.Title
          level={5}
          style={{
            margin: 0,
          }}
        >
          Report
        </Typography.Title>
      </div>
      <Divider style={{ marginTop: 8 }} />
      <Empty />
    </>
  )
}

export default WashReportPage